/**
 * Emoji catalogue for the composer picker.
 *
 * Deliberately small and curated rather than the full Unicode set: a chat
 * composer needs the ~60 that people actually use, and every emoji here is
 * safe to render on Windows without an extra font.
 */
export const EMOJI_GROUPS = [
  {
    id: 'reactions',
    label: 'Reactions',
    emojis: ['😀', '😄', '😁', '🙂', '😉', '😊', '😍', '🤩', '😎', '🤝', '👍', '👎', '🙏', '👌', '✌️', '🤞'],
  },
  {
    id: 'gaming',
    label: 'Gaming',
    emojis: ['🎮', '🕹️', '🎯', '🏆', '🥇', '⚔️', '🛡️', '💎', '🔥', '⚡', '🚀', '🎲', '👾', '🧨', '🪙', '🏅'],
  },
  {
    id: 'commerce',
    label: 'Orders',
    emojis: ['🛒', '💳', '💰', '💸', '🧾', '📦', '✅', '❌', '⏳', '🔒', '🔑', '📩', '⭐', '💜', '🆗', '❗'],
  },
];

export const ALL_EMOJIS = EMOJI_GROUPS.flatMap((group) => group.emojis);
